<template>
  <div class="text-center">
    <nav aria-label="..." class="pt-0">
      <ul class="pagination pagination-sm">
        <li class="page-item" :class="{'disable' : pageObject.current === 1}">
          <button class="page-link" @click="setPage(1)">
            <font-awesome-icon icon="chevron-left" class="ml-1"/>
            <span class="ml-1">First</span>
          </button>
        </li>

        <li v-for="(page,index) in paginationPages" :key="page" class="page-item"
            :class="{ 'disabled': page === '...', 'disabled': page === pageObject.currentPage}">
          <button class="page-link  btn-sm" :class="{'font-weight-bold text-danger' :page === pageObject.currentPage}"
                  @click="setPage(page)">{{ page }}
          </button>
        </li>

        <li class="page-item" :class="{'disable' : pageObject.currentPage === pageObject.lastPage}">
          <button class="page-link" @click="setPage(pageObject.lastPage)">
            <span class="mr-1">Last</span>
            <font-awesome-icon icon="chevron-right" class="ml-1"/>
          </button>
        </li>
      </ul>

      <small>{{
          `${pageObject.from ? pageObject.from : '#'} - ${pageObject.to ?
              pageObject.to :
              '#'} of ${pageObject.total ? pageObject.total : '#'}`
             }}</small>

    </nav>

  </div>
</template>

<script>
export default {
  name: 'BasePagination',

  /** props **/
  props: {
    pageObject: {
      type: Object,
      default: {},
    },
  },
  /** methods**/
  methods: {
    setPage(e) {
      this.$emit('settingPage', e);
    },
  },

  /**  computed  **/
  computed: {
    paginationPages() {
      const pages = [];
      const currentPage = this.pageObject.currentPage;
      const lastPage = this.pageObject.lastPage;

      if (lastPage > 1) {
        let initialLimit = 1;
        if (currentPage + 5 > lastPage) {
          initialLimit = lastPage - 9;
        } else if (currentPage > 6) {
          initialLimit = currentPage - 5;
        }

        initialLimit = initialLimit < 1 ? 1 : initialLimit;
        for (let i = initialLimit; i <= initialLimit + 9; i++) {
          pages.push(i);
          if (i >= lastPage) {
            break;
          }
        }
      }
      return pages;
    },
  },

};
</script>

<style scoped>
.x-small {
  font-size: 70% !important;
  font-weight: 400 !important;
}
</style>
